import { db } from '../../Config/firebase';
import { collection, getDocs, doc, setDoc, deleteDoc, addDoc, serverTimestamp } from 'firebase/firestore';
import { Slot } from '../../app/Subscriptions/types/SubscriptionType';
import { SlotAssignment } from '../../app/Subscriptions/types/SlotAssignmentType';

// Utility functions for slot operations
export const fetchSlotsFromFirestore = async (providerId: string, subscriptionId: string) => {
    try {
        const slotsRef = collection(db, 'ServiceProviders', providerId, 'Subscriptions', subscriptionId, 'Slots');
        const slotsSnapshot = await getDocs(slotsRef);
        const slots: Slot[] = [];
        const assignments: { [key: string]: SlotAssignment[] } = {};
        
        for (const slotDoc of slotsSnapshot.docs) {
            const slotData = slotDoc.data();
            slots.push({ id: slotDoc.id, ...slotData } as Slot);
            
            // Fetch assignments for this slot
            const assignmentsRef = collection(db, 'ServiceProviders', providerId, 'Subscriptions', subscriptionId, 'Slots', slotDoc.id, 'Assignments');
            const assignmentsSnapshot = await getDocs(assignmentsRef);
            assignments[slotDoc.id] = assignmentsSnapshot.docs.map(doc => ({
                studentId: doc.id,
                ...doc.data() as Omit<SlotAssignment, 'studentId'>
            }));
        }
        
        return { slots, assignments };
    } catch (error) {
        console.error('Error fetching slots:', error);
        throw error;
    }
};

export const createSlotInFirestore = async (providerId: string, subscriptionId: string, slotData: any) => {
    try {
        const slotRef = await addDoc(collection(db, 'ServiceProviders', providerId, 'Subscriptions', subscriptionId, 'Slots'), {
            ...slotData,
            createdAt: serverTimestamp(),
            updatedAt: serverTimestamp()
        });
        return slotRef;
    } catch (error) {
        console.error('Error creating slot:', error);
        throw error;
    }
};

export const updateSlotInFirestore = async (providerId: string, subscriptionId: string, slotId: string, slotData: any) => {
    try {
        const slotRef = doc(db, 'ServiceProviders', providerId, 'Subscriptions', subscriptionId, 'Slots', slotId);
        await setDoc(slotRef, {
            ...slotData,
            updatedAt: serverTimestamp()
        }, { merge: true });
    } catch (error) {
        console.error('Error updating slot:', error);
        throw error;
    }
};

export const deleteSlotFromFirestore = async (providerId: string, subscriptionId: string, slotId: string) => {
    try {
        const slotRef = doc(db, 'ServiceProviders', providerId, 'Subscriptions', subscriptionId, 'Slots', slotId);
        await deleteDoc(slotRef);
    } catch (error) {
        console.error('Error deleting slot:', error);
        throw error;
    }
}; 